<div class="baukosten-container-outer-div" id='baukostenContainer' style="overflow-x: auto;white-space: nowrap; overflow-y : auto !important;">

    <div class="baukosten-container-inner-div" id='baukostenContainer'
        style="overflow-x: auto;white-space: nowrap; min-width: 1300px;">

        <div class="gt-flex-dir-row ">
            <dx-chart id="totalsChart" [dataSource]="totalChartData" [title]='totalcostsTitle' class="totals-chart">
                <!-- Tooltip -->
                <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip"
                    [format]="{style:'currency',currency:'EUR'}">
                </dxo-tooltip>
                <!-- Y-axis (currency) -->
                <dxi-value-axis [title]="{ text: amountAxisTitle }"
                    [label]="{ format: {style:'currency',currency:'EUR'} }">
                </dxi-value-axis>

                <!-- Regular Cost (standalone bar) -->
                <dxi-series i18n="@@budget" valueField="totalCostCategoryBudgetNett" name="Budget" type="bar"
                    barOverlapGroup="group1" stack="group1" color="var(--color-primary)">
                </dxi-series>
                <!-- Outstanding Cost (stacked with Paid Amount) -->
                <dxi-series valueField="totalCostCategoryPlanNett" name="Plan" type="bar" stack="group2"
                    color="var(--gt-base-background-color)"
                    [hoverStyle]="{hatching: { direction: 'horizontal', width: 3, step: 6, opacity: 0.5}, opacity: 0.8 }">
                </dxi-series>
                <!-- Plan costs that have actually been commissioned (work item 4839) -->
                <dxi-series valueField="totalCostCategoryPlanNettBeauftragt"
                    name="Plan (beauftragt)" type="bar" stack="group4"
                    color="var(--color-grey-400)">
                </dxi-series>
                <!-- Paid Amount (stacked with Outstanding Cost) -->
                <dxi-series valueField="totalCostCategoryPaidNett" name="Ist" type="bar" stack="group3"
                    color="var(--gt-secondary-color)">
                </dxi-series>

                <!-- Optional: Control bar width to prevent overlap -->
                <dxo-common-series-settings argumentField="projectCostCategoryName" barGroupWidth="0.8" type="bar">
                    <dxo-label visible="true" [format]="{style:'currency',currency:'EUR'}"></dxo-label>
                </dxo-common-series-settings>
            </dx-chart>

            <dx-chart id="primaryCategoriesChart" [dataSource]="primaryChartData" [title]='categoryCostTitle'
                class="primary-categories-charts"
                (onArgumentAxisClick)="openCategoryDetails($event); showSubCatGridVisible = false" [rotated]="true"
                (onPointClick)="onPrimaryCatBarClick($event); showSubCatGridVisible = false">
                <!-- Tooltip -->
                <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip"
                    [format]="{style:'currency',currency:'EUR'}">
                </dxo-tooltip>
                <!-- Y-axis (currency) -->
                <dxi-value-axis [title]="{ text: amountAxisTitle }"
                    [label]="{ format: { style: 'currency', currency: 'EUR' } }">
                </dxi-value-axis>


                <!-- Regular Cost (standalone bar) -->
                <dxi-series valueField="totalCostCategoryBudgetNett" name="Budget" type="bar" barOverlapGroup="group1"
                    stack="group1" color="var(--color-primary)">
                </dxi-series>
                <!-- Outstanding Cost (stacked with Paid Amount) -->
                <dxi-series valueField="totalCostCategoryPlanNett" name="Plan" type="bar" stack="group2"
                    color="var(--gt-base-background-color)"
                    [hoverStyle]="{hatching: { direction: 'horizontal', width: 3, step: 6, opacity: 0.5}, opacity: 0.8 }">
                </dxi-series>
                <!-- Plan costs that have actually been commissioned (work item 4839) -->
                <dxi-series valueField="totalCostCategoryPlanNettBeauftragt"
                    name="Plan (beauftragt)" type="bar" stack="group4"
                    color="var(--color-grey-400)">
                </dxi-series>
                <!-- Paid Amount (stacked with Outstanding Cost) -->
                <dxi-series valueField="totalCostCategoryPaidNett" name="Ist" type="bar"
                    stack="group3" color="var(--gt-secondary-color)">
                </dxi-series>

                <!-- Optional: Control bar width to prevent overlap -->
                <dxo-common-series-settings argumentField="projectCostCategoryName" barGroupWidth="0.8"
                    type="stackedBar">
                    <!--   <dxo-label visible="true"></dxo-label> -->
                </dxo-common-series-settings>
            </dx-chart>
        </div>

        <div *ngIf="selectedCategory !== null" class="cost-details-grid-container">
            <!--   <span [innerText]="selectedCategory.projectCostCategoryName" class="cost-details-title"></span> -->
            <dx-chart id="subCategoriesChart" [dataSource]="subCatChartData" i81n-text
                [title]="subcategoryTitle + selectedCategory.projectCostCategoryName" class="sub-categories-charts"
                (onArgumentAxisClick)="openSubCategoryDetails($event)" (onPointClick)="onSubCatBarClick($event)">
                <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip"
                    [format]="{style:'currency',currency:'EUR'}">
                </dxo-tooltip>
                <!-- Y-axis (currency) -->
                <dxi-value-axis [title]='amountAxisTitle'
                    [label]="{ format: {style:'currency',currency:'EUR'} }">
                </dxi-value-axis>

                <!-- Regular Cost (standalone bar) -->
                <dxi-series valueField="totalCostCategoryBudgetNett" name="Budget" type="bar" barOverlapGroup="group1"
                    stack="group1" color="var(--color-primary)">
                </dxi-series>
                <!-- Outstanding Cost (stacked with Paid Amount) -->
                <dxi-series valueField="totalCostCategoryPlanNett" name="Plan" type="bar" stack="group2"
                    color="var(--gt-base-background-color)"
                    [hoverStyle]="{hatching: { direction: 'horizontal', width: 3, step: 6, opacity: 0.5}, opacity: 0.8 }">
                </dxi-series>
                <!-- Plan costs that have actually been commissioned (work item 4839) -->
                <dxi-series valueField="totalCostCategoryPlanNettBeauftragt"
                    name="Plan (beauftragt)" type="bar" stack="group4"
                    color="var(--color-grey-400)">
                </dxi-series>
                <!-- Paid Amount (stacked with Outstanding Cost) -->
                <dxi-series valueField="totalCostCategoryPaidNett" name="Ist" type="bar"
                    stack="group3" color="var(--gt-secondary-color)">
                </dxi-series>

                <!-- Optional: Control bar width to prevent overlap -->
                <dxo-common-series-settings argumentField="projectCostCategoryName" barGroupWidth="0.8"
                    type="stackedBar">
                    <!--   <dxo-label visible="true"></dxo-label> -->
                </dxo-common-series-settings>
            </dx-chart>
            <div *ngIf="showSubCatGridVisible" class="show-sub-cat-grid-button-container">
                <dx-button *ngIf="!showSubCatGridVisible" icon="chevrondown" (onClick)="showSubCatGrid()" i18n-text
                    text="Sub Category Cost Breakdown" class="show-sub-cat-button"></dx-button>
                <dx-button *ngIf="showSubCatGridVisible" icon="chevronup" (onClick)="showSubCatGrid()" i18n-text
                    text="Sub Category Cost Breakdown" class="show-sub-cat-button"></dx-button>
            </div>
            <span *ngIf="showSubCatGridVisible" [innerText]="selectedSubCategory.projectCostCategoryName"
                class="cost-details-title"></span>
            <div class="gt-flex-dir-row" style="background-color:white;">
                <div class="gt-flex-dir-col" style="width:33%;">
                    <span *ngIf="showSubCatGridVisible" i18n-innerText [innerText]='budgetDataTitle'
                        class="cost-details-title"></span>
                    <dx-data-grid *ngIf="showSubCatGridVisible" class="gt-data-grid-style gt-margin-medium-right"
                        [dataSource]="selectedSubCategory.subCategoryBudgetData" [hoverStateEnabled]="true"
                        [rowAlternationEnabled]="true" showBorders="true">
                        <dxi-column dataField="costAmountNett" i18n-caption caption="Cost Amount Nett"
                            format="#,##0.00 €"></dxi-column>
                        <dxi-column dataField="costNotes" i18n-caption caption="Notes"></dxi-column>
                    </dx-data-grid>
                </div>
                <div class="gt-flex-dir-col" style="width:67%;">
                    <span *ngIf="showSubCatGridVisible" i18n-innerText [innerText]='costDataTitle'
                        class="cost-details-title"></span>
                    <dx-data-grid *ngIf="showSubCatGridVisible" class="gt-data-grid-style gt-margin-medium-left"
                        [dataSource]="selectedSubCategory.subCategoryCostData" [hoverStateEnabled]="true"
                        [rowAlternationEnabled]="true" showBorders="true">
                        <dxi-column i18n-caption caption="Plan" dataField="costAmountNett"
                            format="#,##0.00 €"></dxi-column>
                        <dxi-column i18n-caption caption="Paid" dataField="paidAmountNett"
                            format="#,##0.00 €"></dxi-column>
                        <dxi-column i18n-caption="@@commissioned" caption="Commissioned" dataField="beauftragt"
                            dataType="boolean"></dxi-column>
                        <dxi-column i18n-caption caption="Notes" dataField="costNotes" format="#,##0.00 €"></dxi-column>
                    </dx-data-grid>
                </div>
            </div>

        </div>
    </div>
</div>